import { loadingSpinnerActions } from "../../actions/loadingSpinnerActions";
var OptionTypesReduxProps = {
    mapDispatchToProps: function (dispatch) {
        return {
            onShowSpinner: function () { return dispatch({ type: loadingSpinnerActions.SHOW_SPINNER_MODAL }); },
            onHideSpinner: function () { return dispatch({ type: loadingSpinnerActions.HIDE_SPINNER_MODAL }); },
        };
    }
};
export default OptionTypesReduxProps;



//////////////////
// WEBPACK FOOTER
// ./src/views/PaymentMethods/PaymentMethodsReduxProps.ts
// module id = 401
// module chunks = 0